
import PaymentTypesNotifications from 'common/notifications/-RFC.paymentTypesNotifications';

let _payments = [];
const observablePaymentTypes = new Rx.BehaviorSubject(_payments);

/**
 * @ngdoc service
 * @name repositories.PaymentTypesRepository
 *
 * @description
 * PaymentsRepository.
 */
const PaymentTypesRepository = {

    replace(data) {

        _payments = data;
        observablePaymentTypes.onNext(_payments);
        PaymentTypesNotifications.processCheckPayments(_payments);

    },

    getAll() {

        return _payments;

    },

    getObservable() {

        return observablePaymentTypes;

    },

};

export default PaymentTypesRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.paymentTypesRepository.js